import type { FitResponsePreviewProps } from '@/components/fit-designs/renderers'
import {
  CleanReportFitResponsePreview,
  CurrentFitResponsePreview,
  EvidenceBoardFitResponsePreview,
} from '@/components/fit-designs/renderers'
import type { ComponentType } from 'react'

export interface FitResponseVariantDefinition {
  id: string
  label: string
  description: string
  component: ComponentType<FitResponsePreviewProps>
}

export const fitResponseVariantRegistry: FitResponseVariantDefinition[] = [
  {
    id: 'clean-report',
    label: 'Clean Report',
    description:
      'The production renderer: a single-surface assessment that leads with the decision, rationale, and next step before supporting details.',
    component: CleanReportFitResponsePreview,
  },
  {
    id: 'current',
    label: 'Previous Production',
    description:
      'The metric-grid renderer used before the clean report was promoted to production.',
    component: CurrentFitResponsePreview,
  },
  {
    id: 'evidence-board',
    label: 'Evidence Board',
    description:
      'A side-by-side evidence ledger that separates support for fit from blockers and gaps before the supporting metrics footer.',
    component: EvidenceBoardFitResponsePreview,
  },
]

export const defaultFitResponseVariantId = 'clean-report'
